<div class="login-brand">
  <img class="login-brand__logo" src="assets/icons/Orbit_Icon_Full_Colour.png"
    alt="Supporting Education Group" />
  <div class="login-brand__text">
    <span class="login-brand__name">Supporting Education</span>
    <span class="login-brand__sub">Group</span>
  </div>
</div>
@if (title) {
  <div class="login-brand__title">{{ title }}</div>
}
